import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/study-group/$study-group-id/")({
  beforeLoad: ({ params }) => {
    // デフォルトでstreamページにリダイレクト
    throw redirect({
      to: "/study-group/$study-group-id/stream",
      params,
      replace: true,
    });
  },
  component: () => <div>Redirecting to stream...</div>,
});
